import React from 'react'
import LabelTitleText from 'components/shared/LabelTitleText'
import classnames from 'classnames/bind'
import LinkEditoWithImage from 'src/components/shared/LinkEditoWithImage'
import SocialsGridCard from 'src/components/shared/SocialsGridCard'
import { Newsletter } from 'src/components/slices/NewsletterBanner'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const SocialsGrid = ({ className, intro, links, cards, newsletter }) => {
  return (
    <div className={cx(className)}>
      <LabelTitleText className={css.intro} {...intro} />
      <div className={css.grid}>
        {links &&
          links.map((link, index) => (
            <LinkEditoWithImage key={index} fullBackground {...link} />
          ))}
      </div>
      {cards && (
        <div className={css.grid}>
          {cards.map((card, index) => (
            <SocialsGridCard key={`socialsCard${index}`} {...card} />
          ))}
          {newsletter && (
            <div className={css.newsletterWrapper}>
              <Newsletter className={css.newsletter} newsletter={newsletter} />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

SocialsGrid.defaultProps = {}

export default SocialsGrid
